// extracted by mini-css-extract-plugin
export default {"AgeCheck":"Fnk7uaisr9i11mVvW16X","AgeCheckIcon":"n9jNkPkL5YERjEsqaadV","AgeCheckInput":"yHXAIeKyU8uNPYhu895L"};